export default function DownloadEntry() {
  return (
    <section id="download" className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="rounded-lg overflow-hidden bg-accent-500">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center">
            <div className="p-8 md:p-12 lg:p-14">
              <span className="inline-flex items-center gap-2 h-8 px-3.5 rounded-full bg-foreground-950 text-accent-300 text-xs font-bold whitespace-nowrap">
                <i className="ri-download-2-line" /> 入口 / 下载
              </span>
              <h2 className="mt-5 font-heading text-3xl md:text-5xl font-black leading-tight text-foreground-950">
                下载客户端，蹲新料快人一步
              </h2>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-900/80 md:max-w-lg">
                装好客户端，公共区新料推送、讨论群开聊提醒、粉丝团蹲点更新全部第一时间到位，不用再手动刷新。
              </p>

              <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4">
                <a
                  href="#download"
                  className="h-12 md:h-14 px-7 rounded-full bg-foreground-950 text-background-50 text-sm md:text-base font-bold flex items-center justify-center gap-2 whitespace-nowrap hover:bg-foreground-800 transition-colors cursor-pointer"
                >
                  <i className="ri-apple-fill text-lg" /> iOS 下载
                </a>
                <a
                  href="#download"
                  className="h-12 md:h-14 px-7 rounded-full border-2 border-foreground-950 text-foreground-950 text-sm md:text-base font-bold flex items-center justify-center gap-2 whitespace-nowrap hover:bg-foreground-950/10 transition-colors cursor-pointer"
                >
                  <i className="ri-android-fill text-lg" /> Android 下载
                </a>
                <a
                  href="#top"
                  className="h-12 md:h-14 px-7 rounded-full bg-background-50 text-foreground-950 text-sm md:text-base font-bold flex items-center justify-center gap-2 whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <i className="ri-global-line text-lg" /> 网页版直接进
                </a>
              </div>

              <div className="mt-7 flex flex-wrap items-center gap-x-6 gap-y-3 text-xs md:text-sm font-medium text-foreground-900/75">
                <span className="inline-flex items-center gap-2 whitespace-nowrap">
                  <i className="ri-flashlight-line" /> 新料秒推
                </span>
                <span className="inline-flex items-center gap-2 whitespace-nowrap">
                  <i className="ri-notification-3-line" /> 开聊提醒
                </span>
                <span className="inline-flex items-center gap-2 whitespace-nowrap">
                  <i className="ri-history-line" /> 热评回溯
                </span>
              </div>
            </div>

            <div className="relative w-full h-64 md:h-80 lg:h-full lg:min-h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20floating%20over%20warm%20gold%20gradient%20backdrop%20showing%20abstract%20crimson%20and%20cream%20app%20interface%20blocks%20and%20chat%20bubbles%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20product%20photography%2C%20no%20text%2C%20no%20logos%2C%20editorial%20tech%20aesthetic%2C%20rich%20warm%20tones&width=760&height=760&seq=hlws-app-mock-01&orientation=squarish"
                alt="黑料网社客户端下载示意"
                title="黑料网社 客户端下载 入口"
                className="w-full h-full object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}